<template>
    <application-layout
        :property="property"
        :application="application"
        :experian_attempt="experian_attempt"
        :step_completion_status="$page.props.step_completion_status"
        :step_progress_data="$page.props.step_progress_data"
        :completed_steps_map="$page.props.completed_steps_map"
        current-step="financial_documents"
        sub-title=" - Financial Documents"
    >
        <financial-documents-content 
            :property="property"
            :states="states"
            :application="application"
            :applicant="applicant"
            :documents="documents"
            :experian_attempt="experian_attempt"
            :step_completion_status="$page.props.step_completion_status"
            :step_progress_data="$page.props.step_progress_data"
            :completed_steps_map="$page.props.completed_steps_map"
        />
    </application-layout>
</template>

<script>
import ApplicationLayout from './ApplicationLayout.vue';
import FinancialDocumentsContent from './FinancialDocumentsContent.vue';

export default {
    components: {
        ApplicationLayout,
        FinancialDocumentsContent,
    },
    props: {
        property: Object,
        states: Object,
        application: Object,
        applicant: Object,
        documents: Object,
        experian_attempt: Object,
        step_completion_status: Object,
        step_progress_data: Object,
        completed_steps_map: Object,
    },
}
</script>
